import React from 'react';
import { useComponentTheme, CancelIcon, colors } from '@chegg-ui/theme';
import { FormGroup, FloatingLabel, FloatingLeadingIconPositioner, FloatingTrailingIconPositioner, FloatingError, FloatingHelperText, getThemeConfig, ErrorText } from '../styles';

/**
 * InputWrapper takes care of:
 * - Label and Label Placement
 * - Error state
 * - Helper text
 * - Trailing Icons within the input
 * */
export var FloatingInputWrapper = function FloatingInputWrapper(props) {
  var children = props.children,
      width = props.width,
      disabled = props.disabled,
      labelText = props.labelText,
      leadingIcon = props.leadingIcon,
      errorText = props.errorText,
      errorCta = props.errorCta,
      helperText = props.helperText,
      inputId = props.inputId,
      trailingIcon = props.trailingIcon,
      isFloating = props.isFloating,
      adjustToBackgroundColor = props.adjustToBackgroundColor,
      _props$setLabelOffset = props.setLabelOffset,
      setLabelOffset = _props$setLabelOffset === void 0 ? false : _props$setLabelOffset,
      theme = props.theme,
      trailingIconClickable = props.trailingIconClickable,
      dataTest = props['data-test'];
  var componentTheme = useComponentTheme({
    name: 'InputWrapper',
    theme: getThemeConfig(theme)
  });
  return /*#__PURE__*/React.createElement(FormGroup, {
    width: width,
    errorText: errorText,
    helperText: helperText
  }, /*#__PURE__*/React.createElement(FloatingLabel, {
    id: "".concat(inputId, "_label"),
    htmlFor: inputId,
    isFloating: isFloating,
    setLabelOffset: setLabelOffset,
    "data-test": "".concat(inputId, "_label"),
    adjustToBackgroundColor: adjustToBackgroundColor,
    customTheme: componentTheme,
    hasLeadingIcon: Boolean(leadingIcon)
  }, labelText), /*#__PURE__*/React.createElement("div", {
    style: {
      position: 'relative'
    }
  }, /*#__PURE__*/React.cloneElement(children, {
    'aria-describedby': helperText ? "".concat(inputId, "_helptext") : undefined,
    errorText: errorText
  }), leadingIcon && /*#__PURE__*/React.createElement(FloatingLeadingIconPositioner, {
    disabled: disabled,
    adjustToBackgroundColor: adjustToBackgroundColor
  }, /*#__PURE__*/React.cloneElement(leadingIcon, {
    size: 'xsmall'
  })), trailingIcon && /*#__PURE__*/React.createElement(FloatingTrailingIconPositioner, {
    disabled: disabled,
    adjustToBackgroundColor: adjustToBackgroundColor,
    "data-test": "".concat(dataTest || inputId, "_floating_trailing_icon_positioner"),
    trailingIconClickable: trailingIconClickable
  }, /*#__PURE__*/React.cloneElement(trailingIcon, {
    size: 'xsmall'
  }))), errorText && /*#__PURE__*/React.createElement(FloatingError, {
    id: "".concat(inputId, "_error"),
    "data-test": "".concat(inputId, "_error"),
    role: 'alert',
    customTheme: componentTheme
  }, componentTheme.showCancelIcon ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(CancelIcon, {
    "aria-label": "error",
    iconFill: "circlefill",
    size: "xsmall",
    svgColor: colors.red700
  }), /*#__PURE__*/React.createElement(ErrorText, null, errorText)) : /*#__PURE__*/React.createElement(React.Fragment, null, errorText, errorCta && errorCta)), !errorText && helperText && /*#__PURE__*/React.createElement(FloatingHelperText, {
    id: "".concat(inputId, "_helptext"),
    "data-test": "".concat(inputId, "_helptext"),
    adjustToBackgroundColor: adjustToBackgroundColor,
    customTheme: componentTheme,
    disabled: disabled
  }, helperText));
};
FloatingInputWrapper.displayName = 'FloatingInputWrapper';
export default FloatingInputWrapper;